import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Label,
} from "reactstrap";
import { useContext, useEffect, useRef, useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserHeader from "../components/Headers/UserHeader/UserHeader";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import AdminNavbar from "../components/Navbars/AdminNavbar/AdminNavbar";
import { UserTypeContext } from "../context/UserTypeContext";
import InputStandard from "../components/Inputs/InputStandard";
import { jwtDecode } from "jwt-decode";
import { UserToken } from "../context/hooks/useAuth";
import MenuTop from "../components/MenuTop/MenuTop";

const Profile = () => {
  const { getUsersById, formValuesUsers, setFormValuesUsers, updateUsers } =
    useContext(UserTypeContext);

    const user = jwtDecode(localStorage.getItem("token") || "") as UserToken;

  useEffect(() => {
    const getData = async () => {
      await getUsersById(user.UserId);
    };
    getData();
  }, []);

  const [openModalChangePassword, setOpenModalChangePassword] = useState(false);

  const [editPerfilState, setEditPerfilState] = useState<boolean>(true);

  const photoInputRef = useRef<HTMLInputElement>(null);
  const curriculoInputRef = useRef<HTMLInputElement>(null);

  const handleClickChangePhoto = () => {
    if (photoInputRef.current) {
      photoInputRef.current.click();
    }
  };

  const handleBlur = (valueAtt: any, name: string) => {
    setFormValuesUsers({
      ...formValuesUsers,
      [name]: valueAtt,
    });
  };

  const handleBlurAddress = (valueAtt: any, name: string) => {
    setFormValuesUsers((prevValues: { address: any }) => ({
      ...prevValues,
      address: {
        ...prevValues.address,
        [name]: valueAtt,
      },
    }));
  };

  return (
    <>
      <ToastContainer />
      {/* <UserHeader /> */}
      <MenuTop />
      <LoadingSpinner />
      <Container className="mt-3" fluid >
        <Row key={formValuesUsers.name} className="d-flex justify-content-center">
          <Col className="order-xl-1" xl="12">
            <Card className="shadow" style={{backgroundColor: "#00000000"}}>
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <div className="col-6 xs-8">
                  <span className="title-page-document">MEUS PERFIL</span>
                  </div>
                  <Col className="text-right col-6" xs="4">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {/* <Button
                        style={{
                          color: "#FFF",
                          backgroundColor: "#640764",
                          flexGrow: 1,
                        }}
                        onClick={(e) => setOpenModalChangePassword(true)}
                        size="sm"
                      >
                        Mudar senha
                      </Button> */}
                      {editPerfilState ? (
                        <Button
                          style={{
                            color: "#FFF",
                            backgroundColor: "#DCAC36",
                          }}
                          onClick={(e) => setEditPerfilState(false)}
                          size="sm"
                        >
                          Editar seu perfil
                        </Button>
                      ) : (
                        <>
                          <Button
                            style={{
                              color: "#FFF",
                              backgroundColor: "#DCAC36",
                              flexGrow: 1,
                            }}
                            size="sm"
                            onClick={() => {
                              updateUsers();
                              setEditPerfilState(true);
                            }}
                          >
                            Salvar edições
                          </Button>
                          <Button
                            style={{
                              color: "#DCAC36",
                              border: " 1px solid #DCAC36",
                              flexGrow: 1,
                            }}
                            onClick={() => {
                              setEditPerfilState(true);
                              getUsersById(user.UserId);
                            }}
                            size="sm"
                          >
                            Cancelar
                          </Button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody style={{backgroundColor: "#ffffff"}}>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    INFORMAÇÃO DO USUÁRIO
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlur}
                          name="name"
                          label={"Nome"}
                          value={formValuesUsers.name}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlur}
                          name="email"
                          label={"E-mail"}
                          value={formValuesUsers.email}
                          disabled={true}
                        ></InputStandard>
                      </Col>
                    </Row>
                  </div>

                  <hr className="my-4" />

                  <h6 className="heading-small text-muted mb-4">Endereço</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlurAddress}
                          name="street"
                          label={"Rua"}
                          value={formValuesUsers.address.street}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                      <Col lg="6" className="mb-4">
                        <InputStandard
                          handleChange={handleBlurAddress}
                          name="city"
                          label={"Cidade"}
                          value={formValuesUsers.address.city}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlurAddress}
                          name="country"
                          label={"País"}
                          value={formValuesUsers.address.country}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                      <Col lg="6" className="mb-4">
                        <InputStandard
                          handleChange={handleBlurAddress}
                          name="postalCode"
                          value={formValuesUsers?.address?.postalCode}
                          label="Cep"
                          mask="99999-999"
                          disabled={editPerfilState}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlurAddress}
                          name="state"
                          label={"Estado"}
                          value={formValuesUsers?.address?.state}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                  <h6 className="heading-small text-muted mb-4">
                    Informações Adicionais
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlur}
                          mask="(99) 99999-9999"
                          name="phone"
                          label={"Tel"}
                          value={formValuesUsers.phone}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlur}
                          name="nationalRegisterCode"
                          value={formValuesUsers?.nationalRegisterCode}
                          label="Documento"
                          disabled={editPerfilState}
                        />
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Profile;
